import { useEffect, useState } from "react"

export const CustomField = ({field, fieldName, style, options, value, id, custom_html, onChange, pk = null, many }) => {
    const [selected, setSelected] = useState(value)

    useEffect(() => {
        setSelected(value)
    }, [value])

    const inputType = many ? 'checkbox' : 'radio'
    const localOnChange = (e) => {
        var newSelected;
        var label;
        if(many){
            newSelected = Array.isArray(selected) ? selected : selected ? [selected] : []
            if(newSelected.includes(e.target.value)){
                newSelected = newSelected.filter(item => item !== e.target.value)
            }else{
                newSelected.push(e.target.value)
            }
            label = newSelected.length + ' ' + fieldName
        }else{
            newSelected = e.target.value
            label = options.find(option => option.id === newSelected)?.label
        }
        setSelected(newSelected)
        onChange({'name':fieldName, 'value': newSelected, 'label': label})
    }

    return options.map( (option) =>
        <label 
            key={pk ? pk + '_' + fieldName + '_' + option.id : fieldName + '_' +  option.id} 
            id={pk ? pk + '_' + fieldName + '_' + option.id : fieldName + '_' +  option.id} 
            tabIndex={0} 
            className={`${fieldName}-existing radio radio-card ${style.class}`}
        >
            <input type={inputType} name={fieldName} value={option.id} checked={many ? selected?.includes(option.id) : selected === option.id} onChange={localOnChange}/>
            {option.label ? <div dangerouslySetInnerHTML={{__html: option.label}} /> : null}
    </label>
)}


